/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_C2Inputs */

const en_guide_json_schema_c2 = /** @type {(inputs: Guide_Json_Schema_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A worked registration payload, validated`)
};

const ko_guide_json_schema_c2 = /** @type {(inputs: Guide_Json_Schema_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회원가입 payload 하나를 끝까지 검증해보기`)
};

const ja_guide_json_schema_c2 = /** @type {(inputs: Guide_Json_Schema_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会員登録ペイロードを最後まで検証する`)
};

/**
* | output |
* | --- |
* | "A worked registration payload, validated" |
*
* @param {Guide_Json_Schema_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_c2 = /** @type {((inputs?: Guide_Json_Schema_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_c2(inputs)
	if (locale === "ko") return ko_guide_json_schema_c2(inputs)
	return ja_guide_json_schema_c2(inputs)
});